import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { History as LensIcon } from "@mui/icons-material";
import RunUpload from "./RunUpload";
import RunTable from "./RunTable";

const useStyles = makeStyles()((theme) => ({
    root: { padding: theme.spacing(3) },
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: theme.spacing(1),
        marginBottom: theme.spacing(4),
    },
    headerTitle: { display: "flex", alignItems: "center", gap: theme.spacing(1) },
}));

const Runs = () => {
    const { classes } = useStyles();

    return (
        <Box className={classes.root}>
            <Box className={classes.header}>
                <Box className={classes.headerTitle}>
                    <LensIcon style={{ color: "#7a5cf0", fontSize: 32 }} />
                    <Typography variant="h4">Lens Runs</Typography>
                </Box>
            </Box>

            <RunUpload />
            <RunTable />
        </Box>
    );
};

export default Runs;
